import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-so-ia-prompt',
  templateUrl: './so-ia-prompt.component.html',
  styleUrl: './so-ia-prompt.component.scss'
})
export class SoIaPromptComponent {
  @Input() visible = false;
  @Output() onTouchedButton = new EventEmitter<string>();
  public areaText: string = '';
  public isFirstImproved: boolean = true;
  onClick(){
    const text = this.areaText?.trim() ?? '';
    if (text.length < 3) return;
    this.isFirstImproved =  false;
    this.onTouchedButton.emit(text);
    this.areaText = '';
  }
}
